const ChequeKizMarkGridPluginSettings: IPluginSettings = {
    name: 'Выбытие',
    mnemocode: 'cheque_kiz_mark_plugin',
    permission: 'Cheque',
    columns: [{
        order: 0,
        propertyName: 'idGlobal',
        propertyType: 'string',
        displayName: 'idGlobal',
        visibility: false,
        width: 150
    }, {
        order: 1,
        propertyName: 'docNum',
        propertyType: 'string',
        displayName: 'Номер документа',
        visibility: true,
        width: 150
    }, {
        order: 2,
        propertyName: 'goodsName',
        propertyType: 'string',
        displayName: 'Наименование товара',
        visibility: true,
        width: 150
    }, {
        order: 3,
        propertyName: 'gtinSgtin',
        propertyType: 'string',
        displayName: 'GTIN_SGTIN',
        visibility: true,
        width: 150
    }, {
        order: 4,
        propertyName: 'registratorRequestId',
        propertyType: 'string',
        displayName: 'ID запроса регистратора',
        visibility: true,
        width: 150
    }, {
        order: 5,
        propertyName: 'registratorResponseStatus',
        propertyType: 'string',
        displayName: 'Статус ответа регистратора',
        visibility: true,
        width: 150
    }, {
        order: 6,
        propertyName: 'mdlpRequestId',
        propertyType: 'string',
        displayName: 'ID запроса МДЛП',
        visibility: true,
        width: 150
    }, {
        order: 7,
        propertyName: 'flcErrorText',
        propertyType: 'string',
        displayName: 'Ошибка FLC',
        visibility: true,
        width: 150
    }, {
        order: 8,
        propertyName: 'deviceErrorText',
        propertyType: 'string',
        displayName: 'Ошибка устройства',
        visibility: true,
        width: 150
    }, {
        order: 9,
        propertyName: 'onlineCheckErrorText',
        propertyType: 'string',
        displayName: 'Ошибка проверки онлайн',
        visibility: true,
        width: 150
    }, {
        order: 10,
        propertyName: 'stateText',
        propertyType: 'string',
        displayName: 'Состояние',
        visibility: true,
        width: 150
    }, {
        order: 11,
        propertyName: 'registrationStatusText',
        propertyType: 'string',
        displayName: 'Статус регистрации',
        visibility: true,
        width: 150
    }, {
        order: 12,
        propertyName: 'localCheckStatusText',
        propertyType: 'string',
        displayName: 'Статус локальной проверки',
        visibility: true,
        width: 150
    }, {
        order: 13,
        propertyName: 'onlineCheckStatusText',
        propertyType: 'string',
        displayName: 'Статус проверки онлайн',
        visibility: true,
        width: 150
    }, {
        order: 14,
        propertyName: 'saleAllowed',
        propertyType: 'boolean',
        displayName: 'Продажа разрешена',
        visibility: true,
        width: 150
    }, {
        order: 15,
        propertyName: 'recipeSeriaNumber',
        propertyType: 'string',
        displayName: 'Серия/номер рецепта',
        visibility: true,
        width: 150
    }
    ]
}

export default ChequeKizMarkGridPluginSettings